import classes from "./Spinner.module.scss";

const Spinner = (): JSX.Element => <div className={classes.loader} />;

export default Spinner;
